<template>
  <div class="pageDiv">
    <v-card class="main-card" v-if="!$AuthSvc.isLogin() || !$AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Home Admin</span>
      </v-card-title>

      Must login as ADMIN to view data
    </v-card>

    <v-card class="home-card" v-if="$AuthSvc.isLogin() && $AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Home Admin</span>
      </v-card-title>

      <v-card class="aCard">
        <v-card-title style="padding-bottom:0">
          Add To Home Page:
        </v-card-title>

        <div class="selectDiv">
          <span class="label14">Message Type:</span>
          <select class="dropdown" v-model="event.eventType">
            <option value="Announcement">Announcement</option>
            <option value="Entry">Entry</option>
            <option value="Winners">Winners</option>
            <option value="Sponsor">Sponsor</option>
          </select>
        </div>

        <div class="selectDiv">
          <span class="label14">Expires:</span>
          <input v-model="event.expireDays"> days
        </div>

        <div class="selectDiv">
          <span class="label14">Order:</span>
          <input v-model="event.priority">
        </div>

        <br><br>

        <div class="selectDiv">
          <span class="label14">Format:</span>
          <select class="dropdown" v-model="event.formatType">
            <option value="HTML">HTML</option>
            <option value="TEXT">TEXT</option>
          </select>
        </div>

        <div class="selectDiv">

          <v-card-text>
            <input type="radio" class="radioInput" value="edit" style="width:20px;height:20px" v-model="viewType"> Edit
            <input type="radio" class="radioInput" value="preview" style="width:20px;height:20px" v-model="viewType"> Preview
          </v-card-text>
        </div>
      </v-card>

      <v-card class="messageCard">
        <div>
          <v-btn class="add-button primary-btn" @click="saveEvent()">Save Event</v-btn>
        </div>

        <div class="titleDiv" v-if="viewType === 'edit'">
          <input v-model="event.title" class="messageTitle" placeholder="Enter Title">
        </div>

        <div class="titleDiv" v-if="viewType === 'preview'">
          <span class="label18">{{event.title}}</span>
          <br><br>
        </div>


        <div class="messageDiv">
          <div v-if="event.formatType === 'HTML' && viewType === 'preview'">
            <span v-html="event.message"></span>
          </div>

          <div v-if="event.formatType === 'TEXT' && viewType === 'preview'">
            <pre class="messageText">{{event.message}}</pre>
          </div>

          <div v-if="viewType === 'edit'">
            <textarea class="textareaMessage messageText" v-model="event.message"></textarea>
          </div>
        </div>

      </v-card>

    </v-card>
  </div>
</template>

<script>
  import moment from 'moment';
  import swal from 'sweetalert';

    export default {
      name: "login",
      data: () => ({
        dfwvgaConfig: null,
        event: null,
        viewType: 'edit'
      }),
      mounted: function() {
        this.$AuthSvc.authenticated(this.load);
      },
      methods: {
        load() {
          var _this = this;

          _this.$CommandSvc.get(_this, '/public/config',
              function (data) {
                  _this.dfwvgaConfig = data;
              },
              function (error) {
                  console.log('ERROR: ' + error);
              });

          const urlParams = new URLSearchParams(window.location.search);
          const id = urlParams.get('id')

          if (id !== null && id !== '') {
            this.axios.get('/public/club-events/' + id)
            .then(function (response) {
                _this.event = response.data;
            })
            .catch(function (error) {
                console.log('ERROR: ' + error);
            });
          }
          else {
            _this.initEvent();
          }          
        },
        initEvent() {
            this.event = {
              priority: 1,
              postedTime: moment(),
              expireDays: 7,
              eventType: 'Announcement',
              formatType: 'TEXT',
              title: '',
              message: ''
            };
        },
        printTime(date) {
          return moment(date).format('ddd MMMM DD YYYY hh:mm A');
        },
        saveConfig() {
          this.axios.post('/admin/config', this.dfwvgaConfig)
          .then(function (response) {
              swal("Success", "Config saved.", "info");
          })
          .catch(function (error) {
              swal("Error", "Config FAILED save.", "error");
              console.log('ERROR: ' + error);
          });
        },
        saveEvent() {
          var _this = this;

          if (_this.event.eventType === 'Announcement') {
            _this.event.eventOrder = 1;
          } else if (_this.event.eventType === 'Winners') {
            _this.event.eventOrder = 2;
          } else if (_this.event.eventType === 'Sponsor') {
            _this.event.eventOrder = 3;
          } else if (_this.event.eventType === 'Entry') {
            _this.event.eventOrder = 4;
          }

          _this.axios.post('/admin/club-events', _this.event)
          .then(function (response) {
              _this.initEvent();
              swal("Success", "Event saved.", "info");
          })
          .catch(function (error) {
              swal("Error", "Event FAILED save.", "error");
              console.log('ERROR: ' + error);
          });
        },
        handleFileUpload( event ){
          this.file = event.target.files[0];
        },
        uploadFlyerImage() {
          var _this = this;

          _this.isBusy = true;

          let formData = new FormData();
          formData.append('file', this.file);

          this.axios.post( '/admin/images/sponsors-ad/load/' + _this.flyerName,
            formData,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
          ).then(function() {
            _this.isBusy = false;
            document.getElementById("choose-file-id").value = "";
            swal("Success", "Image uploaded successfully.", "info")
             .then((willDelete) => {
                window.location.reload();
             });
          })
          .catch(function(error){
            _this.isBusy = false;
            swal("Problem", "Unable to load image.", "error");
            console.log('FAILURE!! ' + error);
          });
        }
      }
    }

</script>

<style scoped>
  .home-card {
    padding: 10px;
  }

  .label {
    font-size: 14px;
    font-weight: bold;
    display: inline-block;
    width: 100px;
  }

  .radioInput {
    height: 15px !important;
    margin-left: 20px;
  }

  .player-card {
    margin: 10px 0;
    padding: 10px;
  }

  .player-content {
    display: inline-block;
    float: left;
    width: 70%;
    height: auto;
    vertical-align: top;
  }

  .textareaMessage {
    width: 100%;
    height: 670px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
  }

  .event-card {
      padding: 7px !important;
  }

  .add-button {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 0;
  }

  .inputItem {
    padding: 5px;
  }

  .inputItem  > input {
    width: 100%;
  }

  img {
    width: 100%;
  }

  .selectDiv {
    display: inline-block;
    width: 100%;
    margin-bottom: 10px;
  }

  .selectDiv > .label14 {
    display: inline-block;
    width: 130px !important;
    margin-bottom: 7px;
  }

  .selectDiv input {
    width: 40px;
    padding: 5px;
    border: 1px solid black;
    border-radius: 5px;
  }

  .messageTitle {
    border: 1px solid darkgray;
    border-radius: 7px;
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    padding: 7px;
  }

  .messageTitleDiv {
    width: 100%;
  }

  .messageCard {
    width: 100%;
    height: 800px;
    padding: 7px;
  }

  .messageDiv {
    display: inline-block;
    margin-top: 7px;
    width: 100%;
    height: 730px;
    overflow: scroll;
  }

  pre {
    font-size: 12px;
    font-family: Consolas !imporant;
  }

  @media (min-width: 768px) {
    .selectDiv {
      margin-right: 15px;
      width: 260px;
    }

    .selectDiv > .label14 {
      display: block;
      width: auto;
    }

    .selectDiv input {
      width: 40px;
      padding: 5px;
      border: 1px solid black;
      border-radius: 5px;
    }

    .main-card {
      height: 800px;
    }

    .titleLabel {
      display: inline-block;
      width: 200px;
    }

    img {
      width: 600px;
    }
  }

</style>